import { Component, OnInit, HostListener } from '@angular/core';
import { MultistepsService } from '@app/modules/builder/base/services';
import { SessionService, StepsIdEnum, RequestTypesEnum, ApplicantMessageEnum, LookupsService, StepsCodeEnum, ConstantsService } from '@app/base/core';
import { FormGroup } from '@angular/forms';
import { CanComponentDeactivate } from '@app/base/shared';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SocoHttpService } from '@app/base/soco';
import { AlertService } from '@app/base/alerts/alert.service';


@Component({
  selector: 'app-type',
  templateUrl: './type.component.html',
  styleUrls: ['./type.component.css']
})
export class TypeComponent implements OnInit, CanComponentDeactivate {
  form: FormGroup;
  locationForm: FormGroup;
  formValue;
  alertMsg: any = [];
  requestType: string;
  serviceAddress: any = {};
  stepsIdEnum: typeof StepsIdEnum = StepsIdEnum;
  requestTypesEnum: typeof RequestTypesEnum = RequestTypesEnum;
  applicantMessageEnum: typeof ApplicantMessageEnum = ApplicantMessageEnum;
  lookupsLoaded = false;
  propertyType: string;
  source: { 'id': string; 'itemName': string; }[];

  @HostListener('window:beforeunload', ['$event']) onBeforeUnload(event) {
    if (this.socoHttp.sessionActive) {
      event.preventDefault();
      // Specially for chrome...
      event.returnValue = this.constSvc.changes;
    }
  }

  // constructor
  constructor(public wizardSvc: MultistepsService, public sessionSvc: SessionService,
    public socoHttp: SocoHttpService, public lookupSvc: LookupsService,
    public alertService: AlertService, public constSvc: ConstantsService) {
    this.wizardSvc.syncActiveStep(StepsIdEnum.TYPE);
  }

  // used to initialise services
  ngOnInit() {
    this.form = this.wizardSvc.getStepById(this.stepsIdEnum.TYPE).form;
    this.locationForm = this.wizardSvc.getStepById(this.stepsIdEnum.LOCATION).form;
    this.source = [
      { 'id': 'RESIDENTIAL', 'itemName': 'RESIDENTIAL' },
      { 'id': 'MULTI FAMILY', 'itemName': 'MULTI FAMILY' },
      { 'id': 'COMMERCIAL', 'itemName': 'COMMERCIAL' },
      { 'id': 'INDUSTRIAL', 'itemName': 'INDUSTRIAL' },
      // { 'id': 'MIXED', 'itemName': 'MIXED USE' },
      { 'id': 'SUBDIVISION', 'itemName': 'SUBDIVISION' }
    ];
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Type Builder'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
  }
  next() { this.wizardSvc.nextStep(); }
  back() { this.wizardSvc.previousStep(); }

  // handling page refresh
  canDeactivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot, nextState: RouterStateSnapshot) {

    // If user returns to location page after navigating to type and other pages, the Type Id
    //  is being reset once the user selects a different address
    // had to remove the reset of type since this cause null reference error across pages .
    //  so user after selecting a different address navigates to the
    // type page and further pages withoug using the next button, This will cause the resovleBCAFoundBuilder to be skipped.

    if (this.form) {
      return this.wizardSvc.canDeactivateStep(route, state, nextState);
    } else {
      return true;
    }
  }

  onItemSelect(eve: any) {
    if (eve && eve.id !== null) {
      this.wizardSvc.RequestType = eve.id;
      this.wizardSvc.steps.forEach(f => {
        f.label = this.wizardSvc.getStepTitle(StepsCodeEnum[f.code], eve.id);
        f.title = this.wizardSvc.getStepTitle(StepsCodeEnum[f.code], eve.id);
      });
      this.lookupSvc.loadBuilderBcaLookups(eve.id, this.wizardSvc.serviceAddress.state.short_name);
      this.serviceAddress.state = this.wizardSvc.serviceAddress.state.short_name;
          this.serviceAddress.city = this.wizardSvc.serviceAddress.city;
          this.serviceAddress.county = this.wizardSvc.serviceAddress.county;
          this.serviceAddress.zip = this.wizardSvc.serviceAddress.zip;
      if (this.locationForm.controls['locationStreetName'].value !== null &&
      this.locationForm.controls['locationStreetName'].value !== '' &&
        this.locationForm.controls['locationStreetName'].value !== undefined) {
        this.serviceAddress.streetName = this.locationForm.controls['locationStreetName'].value;
          } else {
            this.serviceAddress.streetName = this.wizardSvc.serviceAddress.street_name;
          }
      if (this.locationForm.controls['locationStreetNumber'].value !== null && this.locationForm.controls['locationStreetNumber'].value !== '' &&
        this.locationForm.controls['locationStreetNumber'].value !== undefined) {
        this.serviceAddress.streetNumber = this.locationForm.controls['locationStreetNumber'].value;
          } else {
            this.serviceAddress.streetNumber = this.wizardSvc.serviceAddress.street_number;
          }
          this.serviceAddress.propertyType = eve.id;
      this.lookupSvc.resolveBCAFoundBuilder(
        this.serviceAddress);
      const sub1 = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
        if (sub1 && val) { sub1.unsubscribe(); }
        this.lookupsLoaded = val;
      });
      this.wizardSvc.getStepById(this.stepsIdEnum.PREMISE).form = this.wizardSvc.buildPremiseForm(eve.id);
      this.wizardSvc.selectedRequestType = true;
    } else {
      this.wizardSvc.selectedRequestType = false;
    }
  }

}
